import BubbleService from "../BubbleService";

class HopeService extends BubbleService {
  constructor() {
    super();
  }

  submitHopeProgram = async (email:string,supports:string) => {
    const result = await this.postWf('explorer_contact',{email,supports})
    return result
  }
}

export default HopeService;